import React from 'react';
import PublicReadiness from './PublicReadiness';

/* Public, unauthenticated Engagement Stack Scan — tornea.app/stack-scan/<slug>.

   The same flow as the readiness scan (paginated questions, instant read-only results, an
   opt-in to have them emailed which is where the CRM lead is captured), pointed at
   /api/public-stack-scan and worded for a scan that asks what a company RUNS rather than what
   it believes. Everything else — layout, the reveal animation, the reCAPTCHA gate, the generic
   form labels — is inherited, which is why this file is six lines and not four hundred.

   ★ The prospect only ever sees engagement_fit_feedback. The second half of the scan (which
   building block to sell first, which objection to expect) is rendered in Machina and has no
   route here at all. */

const STACK_COPY = {
  title: 'stackScanTitle',
  intro: 'stackScanIntro',
  notFound: 'stackScanNotFound',
  contactTitle: 'stackScanContactTitle',
  contactIntro: 'stackScanContactIntro',
  consent: 'stackScanConsent',
  mailMe: 'stackScanMailMe',
  emailed: 'stackScanEmailedNote',
  submitError: 'stackScanSubmitError',
  retry: 'stackScanRetry',
  resultsTitle: 'stackScanResultsTitle',
  ctaButton: 'stackScanCtaButton',
  joinNow: 'stackScanJoinNow',
};

const PublicStackScan = () => (
  <PublicReadiness apiBase="public-stack-scan" copy={STACK_COPY} idPrefix="ss" />
);

export default PublicStackScan;
